import axios from 'axios';

// Use relative URL by default so it works in both dev and production
const API_URL = process.env.REACT_APP_API_URL || '/api';

// Configure axios to include credentials for session cookies
axios.defaults.withCredentials = true;

export const allowlistService = {
  // Get all allowlist entries
  getAllAllowlistEntries: async () => {
    try {
      const response = await axios.get(`${API_URL}/allowlist`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch allowlist entries' };
    }
  },

  // Add a new email to the allowlist
  addAllowlistEntry: async (entryData) => {
    try {
      const response = await axios.post(`${API_URL}/allowlist`, entryData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to add allowlist entry' };
    }
  },

  // Update an existing allowlist entry
  updateAllowlistEntry: async (id, entryData) => {
    try {
      const response = await axios.put(`${API_URL}/allowlist/${id}`, entryData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to update allowlist entry' };
    }
  },

  // Delete an allowlist entry
  deleteAllowlistEntry: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}/allowlist/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to delete allowlist entry' };
    }
  }
};